<template>
  <div class="result">
    <!-- <img alt="logo" class=" uk-align-right uk-margin-medium-left" :src="logo" style="max-width:250px" width="15%"> -->

    <!-- <h3 class="uk-margin-medium-top uk-padding-remove-top no-print">RESUMEN CALIFICACIÓN DE RIESGO</h3> -->
    <h3 class="uk-margin-medium-top">ANÁLISIS DE CAPACIDAD DE PAGO RESPONSABLE</h3>

    <p v-if="loading"> <span uk-spinner="ratio:3"></span> </p>
  <div v-else>
    <div id="res">

    <p class="uk-text-left">Nombre: {{name}} <br> Fecha de registro: {{date}} <span class="print-only">  Ingreso neto: {{ing}} <br>Egresos: {{egg}}</span> </p>
 

    <div>
    <h3  > <br> <span v-if="aprob == 'Solicita la asesoría de tu cooperativa/caja'" style="color:darkgreen"> {{aprob}} </span> <span v-else> {{aprob}}</span></h3>



    </div>
    

    <h3>TABLA DE DATOS</h3>

    <table class="uk-table uk-table-divider uk-table-hover">
      <tbody>
        <tr>
          <td>
            Finalidad
          </td>
          <td>
            {{data['Finalidad']}}
          </td>
        </tr>
        <tr>
          <td>
            1 Total Ingresos
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['1 Total Ingresos']) )}}
          </td>
        </tr>
        <tr>
          <td>
            2 Total Gastos
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['2 Total Gastos']) )}}
          </td>
        </tr>
        <tr style="background-color:lightyellow">
          <td>
            3 Saldo Disponible
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['3 Saldo Disponible']) )}}
          </td>
        </tr>
        <tr>
          <td>
            4 Monto solicitado
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['4 Monto solicitado']) )}}
          </td>
        </tr>
        <tr>
          <td>
            5 Plazo
          </td>
          <td>
            {{ data['5 Plazo']}}
          </td>
        </tr>
        <tr style="background-color:lightyellow">
          <td>
            6 Cuota a pagar
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['6 Cuota a pagar']) )}}
          </td>
        </tr>



        
      </tbody>
    </table>

    </div>

    <div class="uk-text-center uk-child-width-1-2@s no-print" uk-grid>
      
        <div v-if="!fromMail" class="uk-margin">
          <label>Ingresa tu correo para enviar tu  <br></label>
          <input type="email" class="uk-input uk-form-width-medium" v-model="mail" placeholder="Correo electrónico"><button class="uk-button uk-button-primary uk-form-inline" v-on:click="send">enviar resultado</button>
        </div>


        <div class="uk-margin">
          <button type="button" v-on:click="wa" style="background-color: #25D366;" class="uk-button uk-button-primary">Contacta a tu cooperativa por WhatsApp</button>
        </div>

        <div class="uk-margin">
          <button type="button" class="uk-button uk-button-secondary" v-on:click="print">imprimir o guardar resultado</button>
        </div>


        <div v-if="!fromMail" class="uk-margin">
          <button class="uk-button uk-button-default" v-on:click="again">haz otro análisis</button>
        </div>


        <div class="uk-align-center no-print" style="width:100%">
        <div uk-slider="autoplay: true; autoplay-interval: 3000; center: true;">
            <ul class="uk-slider-items uk-grid uk-grid-medium uk-child-width-1-3@m" >
                <li v-for="item in pics">
                    <div uk-lightbox>
                        <a :href="item">
                            <img :src="item" alt="Promo" width="350">
                        </a>
                    </div>
                </li>
            </ul>
         </div>

        </div>

    </div>



<p class="uk-text-right"><small>Los resultados expuestos en este simulador no representan una aprobación crediticia por ningún concepto y son meramente explicativos.</small></p>

    </div>
  </div>
</template>

<script>
export default {
    data: function() {
      return {
        telefono : '',

        data : {},
        
        loading : false,
        mail : '',
        now : String(new Date().getTime()),
        fromMail : false,
        asalariado:this.$score.asalariado,
        date : '',
        name: '',
        ing:0,
        egg:0,
        aprob : '',
        pics:[
        ],
        logo : '../assets/logo.jpg',
      }
    }, 
    computed: {
      total : function() {
        var tot = 0.0
        var count = 0
        for (var i in this.data){
          if(i != 'act' && i != 'asalariado' && i != 'RFC' && i != 'Fecha de nacimiento' && i != 'name' ) tot += parseFloat(this.data[i]['PUNTAJE TOTAL'])
        }
        return tot.toFixed(2)
      },
      color: function() {
        switch (true) {
          case this.total >= 451:
            return "#42f54e"

          case this.total > 401:
            return "#f5e042"

          case this.total > 301:
            return "#f5e042"

          case this.total > 251:
            return "#f59642"

          default:
            return "#f54242"
        }
      },
      text: function() {
        switch (true) {
          case this.total >= 451:
            return "BAJO RIESGO"

          case this.total > 401 :
            return "RIESGO MODERADO"

          case this.total > 301 :
            return "RIESGO MEDIO"

          case this.total > 251:
            return "RIESGO MEDIO ALTO"

          default:
            return "RIESGO ALTO"
        }
      },
    },
    mounted:async function(){
      window.scroll(0,0)
      this.loading = true
      

      if(!sessionStorage.getItem('f')){
        UIkit.notification('No se encontró la empresa')
        this.$router.push('/')
      } else {
          // estas credenciales son públicas 
          // estas credenciales solo tienen acceso a la función pública del correo, al teléfono público de la empresa y a su logo
          await firebase.auth().signInWithEmailAndPassword('7c@mail.com','TfXX8MjDtwUZv1UUDNXMwmYlQW12')

        try {
          await firebase.database().ref('apps/prospecting/' + sessionStorage.getItem('f') + '/telefono').once('value').then(function(s){
            this.telefono = s.toJSON()
          }.bind(this))
          
        } catch (e) {
          console.log(e.message);
        }
      }

        this.date = new Date(parseInt(sessionStorage.getItem('id'))).toLocaleString()
        this.data = JSON.parse(sessionStorage.getItem('data'))
        this.name = this.data.Nombre
        this.mail = this.data.Correo
        this.ing = this.data['1 Total Ingresos']
        this.egg = this.data['1 Total Gastos']
        this.data['Relación entre cuota y disponible'] >= 100 ? this.aprob = 'Solicita la asesoría de tu cooperativa/caja' : this.aprob = 'Solicita asesoría a tu institución financiera.'

        await firebase.database().ref('apps/prospecting/' + sessionStorage.getItem('f') + '/' + sessionStorage.getItem('id')).update(this.data)

        this.loading = false
      

      ///////////////////////
      /////////////////////////
      ////////// PICS /////////


       var storage = firebase.storage().ref('/000 APPS/prospecting/')
      this.pics = []
        await storage.child((sessionStorage.getItem('f') == 'integral') ? 'Caja San Juan Bosco' : sessionStorage.getItem('f') ).listAll().then( async function(res) {
            for(var k in res.items ){
                var url = await res.items[k].getDownloadURL()
                this.pics.push(url)
                if(res.items[k].name == 'logo.jpg'){
                  this.logo = url 
                }
            }
        }.bind(this))

    },
    methods:{
      send : async function() {
        if(this.data){
          this.loading = true


          if(this.mail){
            var sendMail = firebase.functions().httpsCallable('cuatroc') // esta es la función del correo
            var mailData = {
              mail : this.mail,
              res : document.getElementById('res').innerHTML 
            }
            await sendMail(mailData)
            UIkit.notification('Resultados enviados correctamente','success')
            this.fromMail = true
            await firebase.auth().signOut()

          } else {
            UIkit.notification('Debes ingresar una dirección de correo válida','warning')
          }


          
        } else {
          UIkit.notification('No se respondieron todas las preguntas','warning')
        }
        this.loading = false
      },
      print : function() {
        window.print()
      },
      again:function () {
        this.$score = {}
        sessionStorage.removeItem('id')
        sessionStorage.removeItem('data')
        this.$router.push('/')
      },
      wa : function(){
        
            var message = 'Hola, soy ' + this.name + '. Me interesa un crédito con ustedes. Vengo de la app PROSPECTING'             
            var s = encodeURIComponent(message)

            window.location = 'https://wa.me/'+this.telefono+'?text='+s
      },
    }
}
</script>
